import { render, staticRenderFns } from "./TableItemsExpandable.vue?vue&type=template&id=0da3d66c&"
import script from "./TableItemsExpandable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableItemsExpandable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports